export const CHANGE_LOCAL_DATA = 'CHANGE_LOCAL_DATA';


export const setLocalData = (state) => {
  return{
    type: CHANGE_LOCAL_DATA,
    payload: state
  }

};